import { Action } from 'redux'
import { IRequestValues } from '../../../models/Object/saveProfile'
import { UserProfileActions as ObjectActions } from '../../../reducers/userObject/actionNames'

const requestSaveObject = (data: IRequestValues, notNotify = false): IRequestSaveObject => ({
  data,
  type: ObjectActions.RequestSaveObject,
  notNotify: notNotify
})

export interface IRequestSaveObject
  extends Action<ObjectActions.RequestSaveObject> {
  type: ObjectActions.RequestSaveObject
  data: IRequestValues
  notNotify?: boolean
}

export default requestSaveObject

export const requestSaveObjectIsAccepted = (notNotify = false): IRequestSaveObjectIsAccepted => ({
  type: ObjectActions.UpdatingUserProfileIsAccepted,
  notNotify
})
export type IRequestSaveObjectIsAccepted = Action<ObjectActions.UpdatingUserProfileIsAccepted> & any

export const dataObjectSaveIsRejected = (
  errMessage: string,
): IDataForObjectSaveIsRejected => ({
  errMessage,
  type: ObjectActions.UpdatingUserProfileIsRejected,
})

export interface IDataForObjectSaveIsRejected
  extends Action<ObjectActions.UpdatingUserProfileIsRejected> {
  errMessage: string
}
